import { useCallback } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_INIT_TOTP } from '@/app/module/user/definitions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useInitTotp = () => {
  const dispatch = useAppDispatch()
  const [trigger, res] = esApi.useLazyGetUserTotpQuery()

  const initTotp = useCallback(async () => {
    try {
      return await trigger().unwrap()
    } catch (error) {
      dispatch(
        createNotification({
          'init-totp': {
            type: 'error',
            message: getErrorMessage(error, ERROR_INIT_TOTP),
          },
        }),
      )
      return undefined
    }
  }, [dispatch, trigger])

  return [initTotp, res] as const
}
